export default __webpack_public_path__ + "static/media/chantilly10.759a3193.jpg";